import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { RootState } from '../../../stateStore'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import employeeApplyLateApi from '../../../middleware/api/Leaves/ApplyLateArrival/employeeApplyLateApi'
import {
  EmployeeApplyLateProps,
  EmployeeApplyLateSliceState,
} from '../../../types/Leaves/ApplyLateArrival/employeeApplyLateTypes'

const addRegularization = createAsyncThunk(
  'employeeApplyLate/regularization',
  async (props: EmployeeApplyLateProps, thunkApi) => {
    try {
      return await employeeApplyLateApi.regularization(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialLateArrivalReportState: EmployeeApplyLateSliceState = {
  isLoading: ApiLoadingState.idle,
  listSize: 0,
}

const employeeApplyLateSlice = createSlice({
  name: 'employeeApplyLate',
  initialState: initialLateArrivalReportState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRegularization.fulfilled, (state) => {
        state.isLoading = ApiLoadingState.succeeded
      })
      .addCase(addRegularization.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(addRegularization.rejected, (state) => {
        state.isLoading = ApiLoadingState.failed
      })
  },
})

const listSize = (state: RootState): number => state.employeeApplyLate.listSize

const isLoading = (state: RootState): LoadingState =>
  state.employeeApplyLate.isLoading

const employeeApplyLeaveThunk = {
  addRegularization,
}

const employeeApplyLeaveSelectors = {
  listSize,
  isLoading,
}

export const employeeApplyLateService = {
  ...employeeApplyLeaveThunk,
  actions: employeeApplyLateSlice.actions,
  selectors: employeeApplyLeaveSelectors,
}
export default employeeApplyLateSlice.reducer
